import $ from 'jquery';
import { pods_carousels, initPodsCarousel } from './carousel';

export default function() {
  $(document).on('shopify:section:load', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;
    // Is this a carousel?
    if ($(`#${id}`).length > 0) {     
      let index = 0;

      // Has this carousel already been initialized? Destroy it if so...
      if (pods_carousels[id]) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = pods_carousels[id].selectedIndex;
        // Destroy the existing one since it exists
        pods_carousels[id].destroy();
        delete pods_carousels[id];  
      }
      
      // Reinitialize the carousel with new options
      initPodsCarousel($(`#${id}`), index);
    }
  });

  $(document).on('shopify:block:select', (e) => {  
    const id = `PodsCarousel${e.detail.sectionId}`;
    // Is this a carousel?
    if ($(`#${id}`).length > 0) { 
      // Navigate to the correct slide and pause autoplay
      const block_id = e.detail.blockId;
      const multiplier = pods_carousels[id].slides.length / pods_carousels[id].cells.length;
      const index = Math.floor($(`#Pod${block_id}`).index() * multiplier);
      
      pods_carousels[id].select(index);
      pods_carousels[id].pausePlayer();
    }
  });

  $(document).on('shopify:block:deselect', (e) => {
    const id = `PodsCarousel${e.detail.sectionId}`;   
    // Is this a carousel?
    if ($(`#${id}`).length > 0) { 
      // Unpause autoplay
      pods_carousels[id].unpausePlayer();
    }
  });
}